export default {"src":"/_next/static/media/accept-circle-blue-small.e588015a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};